// pulse.directive.ts
import {
    Directive, ElementRef, Input, Renderer2,
} from '@angular/core';

@Directive({ selector: '[pulse]' })
export class PulseDirective {
    /**
     * Should pulse effect be shown
     */
    @Input('pulse') isPulsing: boolean = false;

    /**
     * Reference to current active animation
     */
    private animation: Animation | null = null;

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    /**
     * Handle input changes
     */
    ngOnChanges(): void {
        if (this.isPulsing) {
            this.startPulse();
        } else {
            this.stopPulse();
        }
    }

    /**
     * Starts the pulse animation if it not already going
     * @returns void
     */
    startPulse(): void {
        if (this.animation) {
            return;
        }

        this.animation = this.el.nativeElement.animate(
            [
                { transform: 'scale(1)', offset: 0 },
                { transform: 'scale(1.2)', offset: 0.5 },
                { transform: 'scale(1)', offset: 1 },
            ],
            {
                duration: 1000,
                iterations: Infinity,
                easing: 'ease-in-out',
            },
        );
    }

    /**
     * Stops the pulse animation if it exists
     * @returns void
     */
    private stopPulse(): void {
        if (this.animation) {
            this.animation.cancel();
            this.animation = null;
            this.renderer.setStyle(this.el.nativeElement, 'transform', 'scale(1)');
        }
    }

    /**
     * Stop animation on component destroy
     */
    ngOnDestroy(): void {
        this.stopPulse();
    }
}
